export const ElapsedTimeSince = (date) => {
  const today = new Date()
  const oldDate = new Date(date)

  let diff = today.getTime() - oldDate.getTime()
  let TotalDays = Math.ceil(diff / (1000 * 3600 * 24))
  let min = Math.abs(oldDate.getTime() - today.getTime()) / 1000 / 60

  let dateFormat = new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })

  if (TotalDays === 1 && min <= 60) {
    return Math.round(min) + ' min ago'
  } else if (TotalDays === 1 && min >= 60) {
    return Math.round(min / 60) + ' hours ago'
  } else if (TotalDays > 3) {
    return dateFormat
  } else if (TotalDays <= 3) {
    return TotalDays + (TotalDays > 1 ? ' days ago' : ' day ago')
  }
}
